// Minimal, correct Jalali (Persian) <-> Gregorian conversion.
// Algorithm: Wikipedia "Jalali calendar" conversion formulas.

function g2j(gy: number, gm: number, gd: number): { jy: number; jm: number; jd: number } {
  const g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  let jy = gy <= 1600 ? 0 : 979;
  const g = gy - (gy <= 1600 ? 621 : 1600);
  const gy2 = gm > 2 ? g + 1 : g;
  let days = 365 * g + Math.floor((gy2 + 3) / 4) - Math.floor((gy2 + 99) / 100) + Math.floor((gy2 + 399) / 400) - 80 + gd + g_d_m[gm - 1];
  jy += 33 * Math.floor(days / 12053);
  days %= 12053;
  jy += 4 * Math.floor(days / 1461);
  days %= 1461;
  if (days > 365) {
    jy += Math.floor((days - 1) / 365);
    days = (days - 1) % 365;
  }
  const jm = days < 186 ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
  const jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);
  return { jy, jm, jd };
}

function j2g(jy: number, jm: number, jd: number): { gy: number; gm: number; gd: number } {
  let gy = jy > 979 ? 1600 : 621;
  const j = jy - (jy > 979 ? 979 : 0);
  let days = 365 * j + Math.floor(j / 33) * 8 + Math.floor(((j % 33) + 3) / 4) + 78 + jd + (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
  gy += 400 * Math.floor(days / 146097);
  let d = days % 146097;
  const lp = Math.floor(d / 36524);
  d -= lp * 36524 + Math.floor(lp / 4);
  gy += 100 * Math.floor(d / 36524);
  d %= 36524;
  gy += 4 * Math.floor(d / 1461);
  d %= 1461;
  if (d > 365) {
    gy += Math.floor((d - 1) / 365);
    d = (d - 1) % 365;
  }
  const gm = d < 186 ? 1 + Math.floor(d / 31) : 7 + Math.floor((d - 186) / 30);
  const gd = 1 + (d < 186 ? d % 31 : (d - 186) % 30);
  return { gy, gm, gd };
}

export function parseJalali(s: string): { jy: number; jm: number; jd: number } | null {
  const m = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/.exec(s.trim());
  if (!m) return null;
  return { jy: +m[1], jm: +m[2], jd: +m[3] };
}

export function formatJalali(jy: number, jm: number, jd: number): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${jy}/${p(jm)}/${p(jd)}`;
}

export function stepJalali(s: string, delta: number): string {
  const p = parseJalali(s);
  if (!p) return s;
  let { jy, jm, jd } = p;
  const sign = delta < 0 ? -1 : 1;
  let n = Math.abs(delta);
  while (n-- > 0) {
    jd += sign;
    if (jd > jalaliDaysInMonth(jy, jm)) { jd = 1; jm += 1; if (jm > 12) { jm = 1; jy += 1; } }
    else if (jd < 1) { jm -= 1; if (jm < 1) { jm = 12; jy -= 1; } jd = jalaliDaysInMonth(jy, jm); }
  }
  return formatJalali(jy, jm, jd);
}

export function todayJalali(): string {
  const dt = new Date();
  const j = g2j(dt.getFullYear(), dt.getMonth() + 1, dt.getDate());
  return formatJalali(j.jy, j.jm, j.jd);
}

export function jalaliDaysInMonth(jy: number, jm: number): number {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  const g = j2g(jy, 12, 1);
  const dt = new Date(g.gy, g.gm - 1, g.gd);
  dt.setDate(dt.getDate() + 29);
  const j = g2j(dt.getFullYear(), dt.getMonth() + 1, dt.getDate());
  return j.jm === 12 && j.jd === 30 ? 30 : 29;
}

export function jalaliFirstWeekday(jy: number, jm: number): number {
  const g = j2g(jy, jm, 1);
  const dt = new Date(g.gy, g.gm - 1, g.gd);
  return (dt.getDay() + 1) % 7; // 0 = Saturday
}

export const jalaliMonths = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
export const jalaliWeekdaysFa = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];
export const jalaliWeekdaysEn = ['Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr'];
